import { ConfigurationToolbar } from "../../components/configuration-toolbar.component";

type DaylightProfileToolbarProps = {
  applyingChangesACKStatus: "idle" | "pending" | "success" | "failed";
  onViewHistory: () => void;
  onRestore: () => void;
  onApplyChanges: () => void;
  applyChangesCountdown?: number;
};

export function DaylightProfileToolbar({
  applyingChangesACKStatus,
  onViewHistory,
  onRestore,
  onApplyChanges,
  applyChangesCountdown,
}: DaylightProfileToolbarProps) {
  return (
    <ConfigurationToolbar
      title="Daylight Profile"
      subtitle="Manage schedule timer profiles."
      showViewHistory
      showRestore
      showApplyChanges
      applyingChangesACKStatus={applyingChangesACKStatus}
      applyChangesCountdown={applyChangesCountdown}
      onViewHistory={onViewHistory}
      onRestore={onRestore}
      onApplyChanges={onApplyChanges}
    />
  );
}
